export const dashboardRoute = '/dashboard';
export const homepageRoute = '/';
export const loginRoute = '/login';
